<div class="py-2">
  <router-outlet></router-outlet>
</div>
